// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1vDEC","modalFooterButton":"ModalNotes_modalFooterButton__2qzUl"};